import IconButton from "components/elements/IconButton";
import IconInput from "components/elements/IconInput";
import Table from "components/elements/Table";
import { CLIENT_TYPE_REVERSE } from "core/Constants";
import dataProvider from "core/DataProvider";
import utility from "core/Utils";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const headerMap = {
  id: "ID",
  name: "Name",
  type: "Type",
  client_count: "Clients",
  is_multiple_advertiser: "Multi Advertiser",
  subscription_from: "Period From",
  subscription_to: "Period To",
  total_spots: "Total Spots",
  allocated_spots: "Allocated Spots",
  consumed_spots: "Consumed Spots",
  available_spots: "Available Spots",
  total_users: "Total Users",
  allocated_users: "Allocated Users",
  custom_rate: "Custom Rate",
};

const GroupListing = () => {
  const [groups, setGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadGroups = async () => {
    try {
      let groups = await dataProvider.network.get("groups");
      groups = groups.map(x => ({
        ...x,
        type: CLIENT_TYPE_REVERSE[x.type],
        is_multiple_advertiser: x.is_multiple_advertiser ? "Yes" : "No",
        subscription_from: utility.formatDate(x.subscription_from),
        subscription_to: utility.formatDate(x.subscription_to),
      }));
      setGroups(groups);
    } catch (error) {
      toast.error("Failed to load groups");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGroups();
  }, []);

  return (
    <section id="group-list-container">
      <div className="box mtop pad-1">
        <div className="flex flex-v-center">
          <h3 className="pad-lr">Groups</h3>
          <div className="right flex">
            <div className="el">
              {loading && (
                <div className="loader">
                  <div className="lds-hourglass"></div>
                </div>
              )}
            </div>
            <div className="el pad-lr">
              <IconInput
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search (min 3 character)"
                icon="search"
                style={{ minWidth: "250px" }}
              />
            </div>
          </div>
        </div>
        <div className="mtop">
          <Table headers={headerMap} data={groups} search={search} />
        </div>
      </div>
    </section>
  );
};

export default GroupListing;
